module.exports = __webpack_public_path__ + "img/bioRequest.991681f3.png";